"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Otherwise = void 0;
var react_1 = __importDefault(require("react"));
var react_router_dom_1 = require("react-router-dom");
var Otherwise = function (props) {
    var url = encodeURIComponent(props.location.pathname + props.location.search);
    return (react_1.default.createElement(react_router_dom_1.Redirect, { to: "/?redirect=".concat(url) }));
};
exports.Otherwise = Otherwise;
